module.exports = __webpack_public_path__ + "static/media/utilization_icon.1545d50d.svg";